module.exports = __webpack_public_path__ + "static/media/banner3.89803ae0.jpg";